import React from 'react';
import { ButtonTwoState } from './ButtonTwoState';

export function NotesButton(props: React.ComponentProps<typeof ButtonTwoState>) {
    return (<ButtonTwoState
        {...props}
        icon='pencil'
        dataTest={props.isActive ? 'offer-note-yes' : 'offer-note-no'}
        tooltipText={props.isActive ? 'Смотреть\u00A0заметку' : 'Оставить\u00A0заметку'}
    />);
}
